export default {
  /**
   * http配置参数
   */
  timeout: 6000
}



// WEBPACK FOOTER //
// ./src/http/httpConfig.js